module.exports = __webpack_public_path__ + "img/app-ios.fd262a54.svg";